/**
 * Campaign landing pages (`/lp/*`) — which `WORK_ITEMS` ids each page may show.
 * Resolved through `outcomesFromWorkIds` in `service-lp-content.ts`.
 */
export const LP_WORK_IDS = {
  growth: [
    "anxious-generation",
    "good-inside",
    "safdie-architects",
    "moneta",
    "splitwise",
    "old-port-square",
    "docent-collection",
    "core-firms",
    "inolex-website",
    "inolex-product-selector",
  ] as const,
  medical: [
    "alcor-ised",
    "alcor-pro",
    "osteoboost",
    "amulet-scientific",
  ] as const,
  connectedIntelligence: [
    "chargerhelp-empwr-mobile",
    "splitwise-receipt-scanner",
    "kwieri",
    "insi",
    "moneta-voice-agent",
  ] as const,
  connectedDevices: ["fluidlogic", "osteoboost", "alcor-ised"] as const,
} as const;
